import axios from "axios";
import { API_URL,SERVER_URL } from '../Constants';

class CostCodeService{  
    async getCostCodeResults(query) {
        return axios.get(`${API_URL}getCostCodeResults/`, {params:{query:query}});
    };
};


CostCodeService = new CostCodeService();
export default CostCodeService;